@if (carregando) {
  <div class="loading-overlay">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>
}

<router-outlet></router-outlet>
<p-toast></p-toast>
